// extracted by mini-css-extract-plugin
export default {"container":"src-modules-account-style__container_edzsv"};